var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_company") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,40.5H10.1V10.4A1.59,1.59,0,0,1,10.87,9a1.38,1.38,0,0,1,1.39,0l11.62,7A2.45,2.45,0,0,1,25,18.13Zm-12.91-2H23V18.13a.55.55,0,0,0-.16-.42L12.1,11.27Z",
    transform: "translate(-8.5 -8.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38,40.5H23.09v-23L36.58,23A2.45,2.45,0,0,1,38,25.33Zm-12.91-2H36V25.33a.52.52,0,0,0-.18-.44l-10.73-4.4Z",
    transform: "translate(-8.5 -8.83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7,20.48h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,20.5h-2a1,1,0,0,1,0-2h2a1,1,0,1,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7,24.48h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,24.5h-2a1,1,0,0,1,0-2h2a1,1,0,1,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7,28.48h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,28.5h-2a1,1,0,0,1,0-2h2a1,1,0,1,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7,32.48h-2a1,1,0,1,1,0-2h2a1,1,0,1,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,32.5h-2a1,1,0,0,1,0-2h2a1,1,0,1,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7,36.48h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,36.5h-2a1,1,0,0,1,0-2h2a1,1,0,1,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.73,28.57h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.23,28.59h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.73,32.57h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.23,32.59h-2a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.73,36.57h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.23,36.59h-2a1,1,0,1,1,0-2h2a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,40.5H9.5a1,1,0,0,1,0-2h29a1,1,0,0,1,0,2Z",
    transform: "translate(-8.5 -8.83)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompany);
export default __webpack_public_path__ + "static/media/ic_company.f79abfcb22b0cc66d88814c56af6a5a4.svg";
export { ForwardRef as ReactComponent };